var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./ViewControllerWithCustomCRUDDataSource"], function (require, exports, ViewControllerWithCustomCRUDDataSource_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BoxesController = (function (_super) {
        __extends(BoxesController, _super);
        function BoxesController(options_) {
            var _this = this;
            var vueAdditions = {
                computed: {
                    selectedTenant: {
                        get: function () {
                            var tenant = { Id: null, Name: null };
                            if (window["selectedTenant"] && window["TenantList"] && window["TenantList"].length > 0) {
                                var result = window["TenantList"].filter(function (tenant) { return tenant.Id === window["selectedTenant"]; });
                                if (result.length > 0)
                                    tenant = result[0];
                            }
                            return tenant;
                        }
                    }
                }
            };
            _this = _super.call(this, options_, vueAdditions) || this;
            if (options_.authCode != null && options_.authCode != undefined && options_.authCode != "")
                _this.vueRoot.model.AuthenticationCode = options_.authCode;
            return _this;
        }
        BoxesController.prototype.AfterCreate = function () {
            this.remoteDataSource.at(0).set('Name', this.tmpName);
            this.remoteDataSource.at(0).set('Comment', this.tmpComment);
            this.remoteDataSource.sync();
        };
        BoxesController.prototype.CustomRemoteDatasourceCreate = function (options) {
            var base = this;
            base.tmpName = base.vueRoot.model.Name;
            base.tmpComment = base.vueRoot.model.Comment;
            $.ajax({
                url: base.options.createApiUrl instanceof Function ? base.options.createApiUrl.call(this) : base.options.createApiUrl,
                type: "get", dataType: "json", contentType: "application/json",
                success: function (result) {
                    options.success(result);
                    base.AfterCreate();
                },
                error: function (result) {
                    options.error(result);
                }
            });
        };
        return BoxesController;
    }(ViewControllerWithCustomCRUDDataSource_1.ViewControllerWithCustomCRUDDataSource));
    exports.BoxesController = BoxesController;
    $(function () {
        var optionsList = window["BoxesControllerData"];
        for (var i in optionsList) {
            window["BoxesController" + i] = new BoxesController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=BoxesController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/BoxesController.js
// module id = 385
// module chunks = 0